<template>
  <div class="resume-content" v-if="skillsInfo.length > 0">
    <div class="resume-view-section-header">SKILL</div>

    <div v-if="!noData">
      <div v-bind:key="index" v-for="(skill, index) in skillsInfo">
        <skill-view
          :index="index"
          :skill="skill"
          :print="printSkill"
        ></skill-view>
      </div>
    </div>
    <div style="clear: both"></div>
    <div style="margin-top: 1rem" v-if="noData">
      <div style="color: #ff5252">
        Seems like you haven't added any skill yet!
      </div>
    </div>
  </div>
</template>

<script>
import SkillView from "./skills-card";
import { GET_ALL_SKILLS } from "../../../Api/candidate_api";
export default {
  name: "skill",
  components: {
    SkillView,
  },
  props: {
    skills: Array,
    print: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      skillsInfo: [],
      noData: false,
      printSkill: this.print,
    };
  },
  methods: {
    getAllSkills: function () {
      if (this.skills) {
        this.skillsInfo = this.skills;
      }
      // const self = this;
      // GET_ALL_SKILLS()
      //   .then(function (data) {
      //     self.skills = data;
      //     self.noData = self.skills.length === 0;
      //   })
      //   .catch(function () {});
    },
  },
  mounted() {
    this.getAllSkills();
  },
};
</script>

<style scoped>
.skill-content {
  margin-top: 2rem;
}
.header-text {
  text-align: left;
  background-color: #f7f7f7;
  padding: 0.5rem 1rem;
  color: #050505;
}
.all-skills {
  padding: 1rem !important;
}
.cCode {
  padding: 0.1rem 0.75rem;
  background-color: #fc3832;
  margin: 0 0.5rem 0 1rem;
}
.bg {
  background-color: var(--button-delete-color);
}
.im {
  background-color: goldenrod;
}
.pr {
  background-color: var(--button-color);
}
.ad {
  background-color: #6752f2;
}
.ex {
  background-color: var(--button-save-color);
}
</style>
